import { createGenericDebouncableDataLoader } from '@atlassian/jira-jql-builder-basic-picker';

export { components } from './ui';
export const PACKAGE_NAME = 'jiraIssueTableColumnHeader';
export const TEAM_NAME = 'empanada';
// LDR: https://hello.atlassian.net/wiki/spaces/JFE/pages/2625316871/LDR+Maximum+number+of+columns+to+allow+in+NIN+in+M7.3
export const MAX_COLUMNS = 500;
export const createDebouncedColumnLoader = createGenericDebouncableDataLoader;
